/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Button,
  Switch,
  LinearProgress,
  Stack,
  Typography,
  Chip,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";
import AddIcon from '@mui/icons-material/Add';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import FlashOnIcon from '@mui/icons-material/FlashOn';

const DiscountCoupon = () => {
  const navigate = useNavigate();

  // Sample campaign data
  const campaigns = [
    {
      id: 1,
      name: "Diwali Mega Sale",
      campaignBuild: "AI",
      type: "Discount",
      discountType: "Percentage",
      discountValue: "15%",
      startDate: "20 Nov 2025",
      endDate: "30 Nov 2025",
      minPurchase: "₹500",
      usageLimit: "100",
      createdDate: "10 Nov 2025",
      status: true,
    },
    {
      id: 2,
      name: "Free Shipping Weekend",
      campaignBuild: "Manual",
      type: "Free Shipping",
      discountType: "-",
      discountValue: "-",
      startDate: "15 Dec 2025",
      endDate: "17 Dec 2025",
      minPurchase: "-",
      usageLimit: "Unlimited",
      createdDate: "05 Dec 2025",
      status: false,
    },
  ];

  return (
    <>
      <div className="main_title">
        <h1>Marketing Suite</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Marketing Suite
        </p>
      </div>

      <div className="stats_boxes gap_m">

        {/* Active Campaigns */}
        <a className="cards">
          <div className="data_top">
            <h2>
              5
              <p>Active Campaigns</p>
            </h2>
            <figure className="sucess">
              <CampaignOutlinedIcon fontSize="large" />
            </figure>
          </div>
          <div className="rating_box">
            <p className="green">+ 20% vs last 7 days</p>
          </div>
        </a>

        {/* Total Budget */}
        <a className="cards">
          <div className="data_top">
            <h2>
              AED 323,000
              <p>Total Budget</p>
            </h2>
            <figure className="blue">
              <AttachMoneyOutlinedIcon fontSize="large" />
            </figure>
          </div>
          <div className="rating_box">
            <p style={{ fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '4px' }}>
              <TrendingUpIcon sx={{ fontSize: 16, color: '#f59e0b' }} /> 70% Allocated
            </p>
            <p className="green" style={{ fontSize: '11px', display: 'flex', alignItems: 'center', gap: '4px' }}>
              <CheckCircleIcon sx={{ fontSize: 13 }} /> AED 134,100 remaining
            </p>
          </div>
        </a>

        {/* Revenue 7 */}
        <a className="cards">
          <div className="data_top">
            <h2>
              AED 525,000
              <p>Revenue 7</p>
            </h2>
            <figure className="warning">
              <AttachMoneyOutlinedIcon fontSize="large" />
            </figure>
          </div>
          <div className="rating_box">
            <p style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontSize: '13px', fontWeight: '700' }}>3.1 X</span>
              <span className="green">+ 60% vs last 7 days</span>
            </p>
          </div>
        </a>

        {/* Conversion Rate */}
        <a className="cards">
          <div className="data_top">
            <h2>
              2.8%
              <p>Conversion Rate</p>
            </h2>
            <figure className="sucess">
              <FilterAltOutlinedIcon fontSize="large" />
            </figure>
          </div>
          <div className="rating_box">
            <p className="green">+ 0.6% vs last 7 days</p>
          </div>
        </a>

        {/* Top Campaign */}
        <a className="cards">
          <div className="data_top">
            <h2>
              Diwali Mega Sale
              <p>Top Campaign</p>
            </h2>
            <div style={{
              background: '#22c55e',
              color: '#fff',
              padding: '6px 10px',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '800',
              textAlign: 'center',
              lineHeight: '1.2'
            }}>
              320%
              <div style={{ fontSize: '10px', fontWeight: '500' }}>ROI</div>
            </div>
          </div>
        </a>

      </div>


      <div className="campaign_dashboard_grid">
        {/* Create New Campaign */}
        <div className="campaign_card creation_card">
          <h2>Create New Campaign</h2>
          <p className="subtitle">Launch promotions & maximize engagement</p>

          <div className="creation_actions">
            <div className="action_btn" onClick={() => navigate("add")}>
              <AddIcon /> Create Manually

            </div>
            <div className="action_btn" onClick={() => navigate("ai-campaign-builder")} >
              <div className="ai_icon"><SmartToyOutlinedIcon fontSize="small" color="success" /></div>
              AI Campaign Builder

            </div>
          </div>

        </div>

        {/* AI Insights */}
        <div className="campaign_card ai_insights_card">
          <h3><LightbulbOutlinedIcon /> AI Insights & Recommendations</h3>

          <div className="insight_item">
            <div className="insight_header">
              <div className="icon_box"><SmartToyOutlinedIcon sx={{ fontSize: 14 }} /></div>
              <p><strong>Diwali Mega Sale</strong> has <strong>3.2 x</strong> higher ROI than average. Recommend extending by 3 days.</p>
              <ArrowForwardIosIcon sx={{ fontSize: 12, ml: 'auto', color: '#ccc' }} />
            </div>
            <div className="insight_actions">
              <button className="apply_btn">Apply Recommendation</button>
              <button className="discard_btn">Discard <ArrowForwardIosIcon sx={{ fontSize: 10 }} /></button>
            </div>
          </div>

          <div className="insight_item">
            <div className="insight_header">
              <div className="icon_box" style={{ color: '#f59e0b' }}><FlashOnIcon sx={{ fontSize: 14 }} /></div>
              <p><strong>Free Shipping Weekend</strong> has high reach but low conversion. Consider adding min purchase ✨</p>
            </div>
            <div className="insight_actions">
              <button className="optimized_btn">Create Optimized Campaign</button>
              <button className="discard_btn">Dismiss <ArrowForwardIosIcon sx={{ fontSize: 10 }} /></button>
            </div>
          </div>

          <div className="insight_item">
            <div className="insight_header">
              <div className="icon_box" style={{ color: '#ef4444' }}><HistoryOutlinedIcon sx={{ fontSize: 14 }} /></div>
              <p><strong>2 campaigns</strong> spent 40% of budget with low conversion. Suggest reviewing & optimizing.</p>
            </div>
            <div className="insight_actions">
              <button className="discard_btn">Review Underperforming</button>
              <button className="discard_btn">Pause 2 Campaigns</button>
            </div>
          </div>
        </div>

        {/* Budget Guardrails */}
        <div className="campaign_card guardrails_card">
          <h3>Budget & Spend Guardrails</h3>

          <div className="budget_burn">
            <div className="burn_header">
              <div>
                <h4>Budget Burn <ArrowForwardIosIcon sx={{ fontSize: 10, color: '#f59e0b' }} /></h4>
                <p>AED 188,900 / AED ---</p>
              </div>
              <span className="percentage">58%</span>
            </div>
            <div className="progress_bar_wrapper">
              <div className="progress_fill" style={{ width: '58%' }}></div>
            </div>
          </div>

          <div className="auto_pause_rules">
            <h4><LightbulbOutlinedIcon /> Auto-pause rules</h4>
            <div className="rule_items">
              <div className="rule_item">
                <div className="rule_label"><QueryStatsOutlinedIcon /> If weekly spend exceed 50k</div>
                <Switch size="small" defaultChecked />
              </div>
              <div className="rule_item">
                <div className="rule_label"><QueryStatsOutlinedIcon /> If CPA exceeds AED 180</div>
                <Switch size="small" />
              </div>
              <div className="rule_item">
                <div className="rule_label"><QueryStatsOutlinedIcon /> If Conversion drops, {'<'}1%</div>
                <Switch size="small" defaultChecked />
              </div>
            </div>

            <button className="increase_budget_btn">
              <QueryStatsOutlinedIcon /> Increase 50K Budget
            </button>
          </div>
        </div>
      </div>

      {/* Campaign Table */}
      <div className="cards mt_20">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={""}
              setDebouncedSearchTerm={() => { }}
              placeholder="Search campaigns..."
            />
          </div>

        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No</TableCell>
                <TableCell>Campaign Build</TableCell>
                <TableCell>Campaign Name</TableCell>
                <TableCell>Campaign Type</TableCell>
                <TableCell>Discount Type</TableCell>
                <TableCell>Discount Value</TableCell>
                <TableCell>Start Date</TableCell>
                <TableCell>End Date</TableCell>
                <TableCell>Min Purchase</TableCell>
                <TableCell>Usage Limit</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {campaigns.map((item, index) => (
                <TableRow hover key={item.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    <Chip
                      label={item.campaignBuild}
                      size="small"
                      icon={item.campaignBuild === "AI" ? <SmartToyOutlinedIcon /> : undefined}
                      sx={{
                        backgroundColor: item.campaignBuild === "AI" ? "#ecfdf5" : "#f3f4f6",
                        color: item.campaignBuild === "AI" ? "#059669" : "#6b7280",
                        fontWeight: 600,
                        border: item.campaignBuild === "AI" ? "1px solid #a7f3d0" : "1px solid #e5e7eb",
                        "& .MuiChip-icon": {
                          color: item.campaignBuild === "AI" ? "#059669" : "inherit"
                        }
                      }}
                    />
                  </TableCell>
                  <TableCell>{item.name}</TableCell>
                  <TableCell>{item.type}</TableCell>
                  <TableCell>{item.discountType}</TableCell>
                  <TableCell>{item.discountValue}</TableCell>
                  <TableCell>{item.startDate}</TableCell>
                  <TableCell>{item.endDate}</TableCell>
                  <TableCell>{item.minPurchase}</TableCell>
                  <TableCell>{item.usageLimit}</TableCell>
                  <TableCell>{item.createdDate}</TableCell>
                  <TableCell>
                    <SwitchToggle />
                  </TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => navigate("view")}>
                        <img src="/static/images/eye_icon.svg" alt="View" />
                      </IconButton>

                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default DiscountCoupon;
